import { Button, Icon } from 'ui';

const CompleteNowItem = () => (
  <Button icon={<Icon icon="check-line" />} size="small" type="primary">
    Complete now
  </Button>
);

export default CompleteNowItem;
